<template>
  <hm-content title>
    <div slot="header">
      <hm-step
        :steps="steps"
        :step="4"
        :disabledFirst="disabledFirst"
        disabledNext
      ></hm-step>
    </div>
    <div class="flex flex-between item-center mb20">
      <div class="flex">
        <el-button type="primary" size="small" @click="showActivity"
          >添加关联活动</el-button
        >
      </div>
      <div class="flex flex-end item-center">
        <div class="table-panel flex flex-end">
          <el-input
            class="mr10"
            size="small"
            placeholder="请输入促销名称"
            v-model="keywords"
            @input="filterActivityName"
            clearable
          ></el-input>
        </div>
        <div @click="batchDelete">
          <span class="delete-icon hmicon icon-shanchu"></span>批量删除
        </div>
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        :data="connectedActiviesList"
        style="width: 100%"
        id="connectedTable"
        ref="connectedTable"
        size="small"
        @selection-change="connectedGetChecked"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="promotionName"
          label="促销名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="type"
          label="促销类型"
        >
          <template slot-scope="scope">
            {{ scope.row.typeName }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="startDateFormat"
          label="促销时间"
        >
          <template slot-scope="scope">
            <span class="time">
              {{ scope.row.startDate }}至{{ scope.row.endDate }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="促销状态"
        >
          <template slot-scope="scope">
            <span
              class="status danger"
              v-show="scope.row.enabledState === 'disabled'"
              >下线</span
            >
            <span
              class="status success"
              v-show="scope.row.enabledState === 'enable'"
              >上线</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                class="blue"
                size="small"
                @click="remove(scope.$index)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="hm-pagination mb20">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div> -->
    </div>

    <div class="flex flex-center mt20">
      <el-button type="primary" size="small" @click="back">上一步</el-button>
      <el-button type="primary" size="small" @click="submit('wait_commit')"
        >保存</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="showPreviewModal('wait_audit')"
        >预览并提交</el-button
      >
    </div>

    <el-dialog
      title="关联活动"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div class="flex mb20">
        <el-select
          clearable
          v-model="promotionCode"
          placeholder="促销类型"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in activityChildCategoryList"
            :key="item.promotionCode"
            :label="item.typeName"
            :value="item.promotionCode"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="auditState"
          placeholder="审核状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="待提交" value="wait_commit"></el-option>
          <el-option label="待审核" value="wait_audit"></el-option>
          <!-- <el-option label="审核中"
                     value="in_audit"></el-option> -->
          <el-option label="审核通过" value="audit_pass"></el-option>
          <el-option label="已驳回" value="reject"></el-option>
        </el-select>
        <el-select
          clearable
          v-model="enabledState"
          placeholder="促销状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="上线" value="enable"></el-option>
          <el-option label="下线" value="disabled"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="promotionName"
          placeholder="输入促销名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
      <div class="table mb20">
        <el-table
          stripe
          border
          class="mb20"
          ref="activityList"
          :data="activityList"
          style="width: 100%"
          id="activityList"
          size="small"
          @row-click="activityListTableSelect"
          @selection-change="getChecked"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            :index="
              (index) =>
                index + (currentPageActivity - 1) * pageSizeActivity + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="promotionName"
            label="促销名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="type"
            label="促销类型"
          >
            <template slot-scope="scope">
              <div class="table-status flex item-center">
              <span
                class="status success-bg"
                v-show="scope.row.timeStatus === 'running'"
              ></span>
              <span
                class="status gray-bg"
                v-show="scope.row.timeStatus === 'notStarted'"
              ></span>
              <span
                class="status danger-bg"
                v-show="scope.row.timeStatus === 'end'"
              ></span>
              {{ scope.row.typeName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="startDateFormat"
            label="促销时间"
          >
            <template slot-scope="scope">
              <span class="time">
                {{ scope.row.startDate }}至{{ scope.row.endDate }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="审核状态"
          >
            <template slot-scope="scope">
              <span
                class="status blue"
                v-show="scope.row.auditState === 'wait_commit'"
                >待提交</span
              >
              <span
                class="status blue"
                v-show="scope.row.auditState === 'wait_audit'"
                >待审核</span
              >
              <!-- <span class="status blue"
                  :class="scope.row.auditState"
                  v-show="scope.row.auditState === 'in_audit'">审核中</span> -->
              <span
                class="status success"
                :class="scope.row.auditState"
                v-show="scope.row.auditState === 'audit_pass'"
                >审核通过</span
              >
              <span
                class="status danger"
                :class="scope.row.auditState"
                v-show="scope.row.auditState === 'reject'"
                >已驳回</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="enabledState"
            label="促销状态"
          >
            <template slot-scope="scope">
              <span
                class="status danger"
                v-show="scope.row.enabledState === 'disabled'"
                >下线</span
              >
              <span
                class="status success"
                v-show="scope.row.enabledState === 'enable'"
                >上线</span
              >
            </template>
          </el-table-column>
        </el-table>
        <hm-status />
      </div>

      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalActivity"
          @current-change="pagingActivity"
          @size-change="handleSizeChangeActivity"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageActivity"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="预览"
      :visible.sync="previewDiaogVisible"
      width="1200px"
      :close-on-click-modal="false"
      @close="previewDiaogVisible = false"
    >
      <div class="detail-container">
        <div class="activity mb20">
          <div class="caption">创建促销</div>
          <ul>
            <li class="flex">
              <div class="title">促销活动</div>
              <div class="content">
                {{ details.basicConfigInfo.promotionName }}
              </div>
            </li>
            <li class="flex" v-if="couponLevelList.length">
              <div class="title">促销层级</div>
              <div class="content">
                {{ pasLevelName }}
              </div>
            </li>
            <li class="flex">
              <div class="title">基础价&nbsp;&nbsp;&nbsp;</div>
              <div class="content">
                <span
                  v-show="
                    details.basicConfigInfo.assignPriceType === 'promotion'
                  "
                  >会员价</span
                >
                <span
                  v-show="details.basicConfigInfo.assignPriceType === 'retail'"
                  >零售价</span
                >
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'all'"
            >
              <div class="title">优惠时间</div>
              <div class="content primary" v-if="details.pasCalendars">
                {{ details.pasCalendars.promotionStartTime }}至{{
                  details.pasCalendars.promotionEndTime
                }}
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'special'"
            >
              <div class="title">优惠时间</div>
              <div class="content primary">
                {{ details.dateConfigInfo.promotionStartDate }}至{{
                  details.dateConfigInfo.promotionEndDate
                }}
              </div>
            </li>
            <li
              class="flex"
              v-if="details.basicConfigInfo.runningTimeType === 'special'"
            >
              <div class="title">特定时段</div>
              <div>
                <div
                  class="content primary"
                  v-if="details.dateConfigInfo.dateType === 'day'"
                >
                  <div>每{{ details.dateConfigInfo.dateValue }}天生效</div>
                </div>
                <div class="content primary">
                  <div
                    class="flex"
                    v-if="details.dateConfigInfo.dateType === 'week'"
                  >
                    每
                    <div
                      class="mr10"
                      v-for="(v, i) in details.dateConfigInfo.dateValues"
                      :key="i"
                    >
                      {{ "周" + v }}
                    </div>
                    生效
                  </div>
                  <div
                    class="flex"
                    v-if="details.dateConfigInfo.dateType === 'month'"
                  >
                    每月
                    <div
                      class="mr10"
                      v-for="(v, i) in details.dateConfigInfo.dateValues"
                      :key="i"
                    >
                      {{ v }}
                    </div>
                    日生效
                  </div>
                  <div v-for="(v, i) in details.dateConfigRange || []" :key="i">
                    {{ v.promotionStartTime }} 至 {{ v.promotionEndTime }}
                  </div>
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">参与门店</div>
              <div class="content">
                <div
                  v-if="
                    details.pasOutlets.length === 1 &&
                    details.pasOutlets[0].outletId === '0'
                  "
                >
                  全部门店
                </div>
              </div>
              <div class="content">
                <div v-for="(v, i) in details.storeList || []" :key="i">
                  {{ v.name }}
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">销售渠道</div>
              <div class="content">
                <div v-for="(v, i) in details.platformModels || []" :key="i">
                  {{ v.platformName }}
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">会员群组</div>
              <div class="content">
                <div
                  v-if="
                    details.memberGroupList.length === 1 &&
                    details.memberGroupList[0].groupId === '0'
                  "
                >
                  全部会员群组
                </div>
              </div>
              <div class="content">
                <div v-for="(v, i) in details.groupListRes || []" :key="i">
                  {{ v.groupAppellation }}
                </div>
              </div>
            </li>
            <li class="flex">
              <div class="title">促销标签</div>
              <div class="content flex">
                <el-tag v-for="(v, i) in details.pasLabels" :key="i">
                  {{ v.labelKey }}
                </el-tag>
              </div>
            </li>
          </ul>
        </div>
        <div
          class="goods mb20"
          v-if="details.pasGoods && details.pasGoods.length"
        >
          <div class="caption">选择商品</div>
          <el-table
            stripe
            :data="details.pasGoods || []"
            style="width: 100%"
            id="table"
            border
            size="small"
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrType"
              label="类型"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'brand'">添加品牌</div>
                <div v-if="scope.row.attrType === 'goods'">添加商品</div>
                <div v-if="scope.row.attrType === 'barcode'">添加sku商品</div>
                <div v-if="scope.row.attrType === 'category'">添加品类</div>
                <div v-if="scope.row.attrType === 'attribute'">添加属性</div>
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="attrId"
              label="编号（只显示商品货号/条码）"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.attrType === 'goods'">
                  货号:{{ scope.row.attrId }}
                </div>
                <div v-else-if="scope.row.attrType === 'barcode'">
                  条码:{{ scope.row.attrId }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="attrValue"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="showPrice"
              label="零售价"
            ></el-table-column>
            <el-table-column header-align="center" align="center" label="状态">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.useable === 'white'"
                  class="select-type white"
                  >白</span
                >
                <span
                  v-if="scope.row.useable === 'black'"
                  class="select-type black"
                  >黑</span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="rule mb20">
          <div class="caption">创建规则</div>
          <ul>
            <li class="flex">
              <div class="title" style="width: 56px">促销类型</div>
              <!-- 叠加赠送 -->
              <div
                class="content flex-1"
                v-if="details.pasSuperpositionGiftRuleLimitModel"
              >
                <div class="flex">
                  <div class="mr10">
                    叠加
                    <span class="primary">
                      {{
                        details.pasSuperpositionGiftRuleLimitModel.giftMode ===
                        "num"
                          ? "按数量"
                          : "按金额"
                      }}
                    </span>
                  </div>
                  <div class="mr10">
                    每买满
                    <span class="primary">
                      {{
                        details.pasSuperpositionGiftRuleLimitModel
                          .purchasesAmount
                      }}
                    </span>
                    <span
                      v-if="
                        details.pasSuperpositionGiftRuleLimitModel.giftMode ===
                        'num'
                      "
                      >件</span
                    >
                    <span v-else>元</span>
                    循环赠送以下商品,并且用户无需选择
                  </div>
                </div>
                <div>
                  <!-- 防止被缓存加上v-if  -->
                  <el-table
                    stripe
                    v-if="previewDiaogVisible"
                    :data="details.pasSuperpositionGiftRuleGoodsModelList"
                    style="width: 100%"
                    id="table"
                    border
                    size="small"
                  >
                    <el-table-column
                      type="index"
                      width="50"
                      label="序号"
                    ></el-table-column>
                    <el-table-column
                      show-overflow-tooltip
                      label="商品货号/条码"
                    >
                      <template slot-scope="scope">
                        <div v-if="scope.row.attrType === 'goods'">
                          货号:{{ scope.row.attrId || scope.row.goodsSn }}
                        </div>
                        <div v-else-if="scope.row.attrType === 'barcode'">
                          条码:{{ scope.row.attrId || scope.row.barcode }}
                        </div>
                        <div v-else>
                          <span v-if="scope.row.goodsSn">货号:{{scope.row.goodsSn}}</span>
                          <span v-if="scope.row.barcode">条码:{{scope.row.barcode}}</span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="goodsName"
                      label="商品名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="shopPrices"
                      label="零售价"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="giftNum"
                      label="商品数量"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="giftUpperLimitNum"
                      label="赠送上限"
                    ></el-table-column>
                  </el-table>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="rule mb20">
          <div class="caption">关联活动</div>
          <ul>
            <li class="flex">
              <div class="title" style="width: 56px">促销类型</div>
              <!-- 叠加赠送 -->
              <div class="content flex-1" v-if="connectedActiviesList.length">
                <div>
                  <!-- 防止被缓存加上v-if  -->
                  <el-table
                    stripe
                    border
                    :data="connectedActiviesList"
                    style="width: 100%"
                    id="connectedTable"
                    ref="connectedTable"
                    size="small"
                    v-if="previewDiaogVisible"
                  >
                    <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      :index="
                        (index) => index + (currentPage - 1) * pageSize + 1
                      "
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="promotionName"
                      label="促销名称"
                    ></el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="type"
                      label="促销类型"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.typeName }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="startDateFormat"
                      label="促销时间"
                    >
                      <template slot-scope="scope">
                        <span class="time">
                          {{ scope.row.startDate }}至{{ scope.row.endDate }}
                        </span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="enabledState"
                      label="促销状态"
                    >
                      <template slot-scope="scope">
                        <span
                          class="status danger"
                          v-show="scope.row.enabledState === 'disabled'"
                          >下线</span
                        >
                        <span
                          class="status success"
                          v-show="scope.row.enabledState === 'enable'"
                          >上线</span
                        >
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="flex flex-center">
        <el-button size="small" type="primary" @click="submit('wait_audit')"
          >确 定</el-button
        >
        <el-button size="small" @click="previewDiaogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </hm-content>
</template>

<script>
import { getLoginUser } from "@/utils/auth";
import HmStep from "@/components/HmStep";
import HmStatus from "@/components/HmStatus";
import {
  removeCookie,
  setCookie,
  getCookie,
  queryActivityCategory,
  arrayUnique2,
} from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  components: { HmStep,HmStatus },
  data() {
    return {
      storeCode: "",
      steps: [
        {
          link: "SelectActivity",
          name: "选择促销类型",
        },
        {
          link: "CreatActivity",
          name: "创建促销",
        },
        {
          link: "CreatGoodsRule",
          name: "创建规则",
        },
        {
          link: "ConnectedActivities",
          name: "关联活动",
        },
      ],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      connectedActiviesList: [],
      keywords: "",
      disabledFirst: false,
      connectedCheckedRow: [],
      connectedNum: 0,
      checkedRow: [],
      num: 0,
      activityList: [],
      dialogVisible: false,
      totalActivity: 0,
      currentPageActivity: 1,
      pageSizeActivity: 10,
      promotionCode: "SpecialPrice-SpecialPrice",
      promotionName: "",
      auditState: "audit_pass",
      timeStatus: "all",
      enabledState: "enable",
      currentBasicInfoIdList: [],
      selectedData: [],
      isCopy: false,
      previewDiaogVisible: false,
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: [],
        memberGroupList: [],
        platformModels: [],
      },
      couponLevelList: [],
      parentId: "",
      activityChildCategoryList: [],
    };
  },
  computed: mapGetters([
    "activityCategoryList"
  ]),
  watch: {
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach(v => {
        v.nodes.forEach(o => {
          //特价,组合价
          if(
            o.promotionCode === 'SpecialPrice-SpecialPrice' || 
            o.promotionCode === 'CombinationPrice-packagePrice' || 
            o.promotionCode === 'FullDiscount-NumDiscount' 
          )
          {
            this.activityChildCategoryList = this.activityChildCategoryList.concat(
              o
            );
          }
        }) 
      });
    },
  },
  created() {
    const { type, subType } = this.$route.query;
    this.disabledFirst = type === "edit";
    this.isCopy = subType === "copy";
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
  },
  mounted() {
    const STEP = getCookie({ key: "STEP" });
    this.parentId = STEP.step1.parentId;
    this.queryActivityList();
    this.$store.dispatch("queryActivityCategoryList");
    this.cookieEcho(STEP.step5);
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingActivity(page) {
      this.currentPageActivity = page;
      this.queryActivityList();
    },
    handleSizeChangeActivity(size) {
      this.currentPageActivity = 1;
      this.pageSizeActivity = size;
      this.queryActivityList();
    },
    async queryList() {},
    async queryActivityList() {
      let params = {
        pageNo: this.currentPageActivity,
        pageSize: this.pageSizeActivity,
        storeCode: this.storeCode,
        promotionCode: this.promotionCode,
        promotionName: this.promotionName,
        auditState: this.auditState,
        timeStatus: this.timeStatus,
        enabledState: this.enabledState,
        selectedRelationInfoId: this.currentBasicInfoIdList,
      };
      const { result } = await this.$store.dispatch(
        "querySelectableRelationPromotionList",
        params
      );
      const { records, total } = result;
      this.activityList = records;
      console.log("this.activityList:", this.activityList);
      this.activityList.forEach((v) => {
        v.typeName = queryActivityCategory({
          parentId: v.promotionCode.split("-")[0],
          childId: v.promotionCode.split("-")[1],
        }).childTypeName;
      });
      // this.activityList = JSON.parse(JSON.stringify(this.activityList));
      this.totalActivity = total;
      console.log("this.checkedRow:", this.checkedRow);
      this.$nextTick(() => {
        this.activityList.map((v) => {
          if (this.connectedActiviesList.findIndex((o) => o.id === v.id) >= 0) {
            this.$refs.activityList.toggleRowSelection(v);
          }
        });
      });
    },
    search() {
      if(!this.promotionCode){
        this.$message({
          message: "请选择促销类型",
          type: "warning",
        });
        return;
      }
      this.currentPage = 1;
      this.queryActivityList();
    },
    showActivity() {
      this.currentPageActivity = 1;
      this.queryActivityList();
      this.dialogVisible = true;
    },
    filterActivityName() {
      this.connectedActiviesList = this.selectedData.filter((v) =>
        v.promotionName.includes(this.keywords)
      );
    },
    getChecked(selection) {
      this.checkedRow = selection;
      this.num = selection.length;
    },
    connectedGetChecked(selection) {
      this.connectedCheckedRow = selection;
      this.connectedNum = selection.length;
    },
    batchDelete() {
      if (this.connectedCheckedRow.length) {
        this.$confirm("删除所有选中的结果？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.selectedData = this.selectedData.filter(
            (v) =>
              !this.connectedCheckedRow.some(
                (item) => String(v.id) === String(item.id)
              )
          );
          this.connectedActiviesList = this.selectedData;
          this.connectedCheckedRow = [];
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    save() {
      const data = this.selectedData.concat(this.checkedRow);
      this.selectedData = [...new Set(data)];
      this.selectedData = arrayUnique2(this.selectedData, "id");
      this.connectedActiviesList = this.selectedData;
      this.total = this.connectedActiviesList.length;
      this.dialogVisible = false;
      this.checkedRow = [];
      console.log("this.connectedActiviesList:", this.connectedActiviesList);
    },
    close() {
      this.dialogVisible = false;
    },
    activityListTableSelect(row, column, event) {
      this.$refs.activityList.toggleRowSelection(row);
    },
    remove(i) {
      this.selectedData.splice(i, 1);
      this.connectedActiviesList = this.selectedData;
    },
    back() {
      this.$router.back(-1);
    },
    submit(auditState) {
      const STEP = getCookie({ key: "STEP" });
      const { id } = STEP.step1;
      console.log("this.parentId:", this.parentId);
      if (!this.connectedActiviesList.length) {
        this.$message({
          type: "error",
          message: "请先关联活动！",
        });
      } else {
        const data = getCookie({ key: "STEP" });
        const params = Object.assign(this.getCommonParams(STEP, auditState));
        let pasSuperpositionGiftRelationPromotionModels = [];         
        this.connectedActiviesList.forEach((v) => {
          pasSuperpositionGiftRelationPromotionModels.push({
            relationBasicInfoId: v.relationBasicInfoId || v.id,
          });
        });
        Object.assign(params, STEP.step4);
        console.log(
          "pasSuperpositionGiftRelationPromotionModels:",
          pasSuperpositionGiftRelationPromotionModels
        );
        params.pasSuperpositionGiftRelationPromotionModels =
          pasSuperpositionGiftRelationPromotionModels;
        console.log("params:", params);
        if (this.disabledFirst && !this.isCopy) {
          console.log("编辑!!!")
          params.basicConfigInfo.id = id;
          this.$store.dispatch("editSuperpositionGift", params).then(() => {
            this.backAndClear();
          });
        } else {
          console.log("新建!!!")
          this.$store.dispatch("createSuperpositionGift", params).then(() => {
            this.backAndClear();
          });
        }
      }
    },
    showPreviewModal(auditState) {
      const STEP = getCookie({ key: "STEP" });
      switch (this.parentId) {
        case "SuperpositionGift":
          if (!this.connectedActiviesList.length) {
            this.$message({
              type: "error",
              message: "请先关联活动！",
            });
          }
          this.details = Object.assign(this.getCommonParams(STEP, auditState), {
            pasSuperpositionGiftRuleLimitModel:
              STEP.step4.pasSuperpositionGiftRuleLimitModel,
            pasSuperpositionGiftRuleGoodsModelList:
              STEP.step4.pasSuperpositionGiftRuleGoodsModelList,
            connectedActiviesList: this.connectedActiviesList,
          });
          console.log("this.details:", this.details);
          this.previewDiaogVisible = true;
          break;
        default:
          break;
      }
      this.details = Object.assign(this.details, {
        storeList: STEP.step2.storeListRes,
      });
    },
    getCommonParams(STEP, auditState) {
      console.log("STEP: ", STEP);
      const params = {
        basicConfigInfo: {
          auditState,
          promotionCode: STEP.step1.parentId + "-" + STEP.step1.childId,
          assignPriceType: STEP.step2.assignPriceType,
          introText: STEP.step2.introText,
          promotionName: STEP.step2.promotionName,
          runningTimeType: STEP.step2.runningTimeType,
          pasLevel: STEP.step2.pasLevel,
          plusTag: STEP.step2.plusTag,
          couponUsable: STEP.step2.couponUsable,
        },
        dateConfigInfo: {
          dateType: STEP.step2.dateType,
          dateValues:
            STEP.step2.dateType === "day"
              ? [STEP.step2.dateValue]
              : STEP.step2.dateValue,
          promotionStartDate: STEP.step2.promotionStartDate,
          promotionEndDate: STEP.step2.promotionEndDate,
        },
        dateConfigRange: STEP.step2.dateConfigRange,
        pasCalendars: {
          promotionStartTime: STEP.step2.promotionStartTime,
          promotionEndTime: STEP.step2.promotionEndTime,
        },
        pasGoods: STEP.step3,
        pasLabels: STEP.step2.tags,
        pasOutlets: STEP.step2.storeListFormat,
        platformModels: STEP.step2.platformModels,
        memberGroupList: STEP.step2.groupListFormat,
        groupListRes: STEP.step2.groupListRes,
        showUpperNum: STEP.step2.showUpperNum,
      };
      return params;
    },
    backAndClear() {
      this.$router.push({ name: "ActivityList" });
      removeCookie({ key: "STEP" });
    },
    cookieEcho(step5) {
      console.log("this.cookieEcho",this.activityChildCategoryList);
      if (step5) {
        if(this.isCopy){
          this.connectedActiviesList = [];
        }else{
        this.connectedActiviesList = step5.pasSuperpositionGiftRelationPromotionModels;        
        this.connectedActiviesList.forEach(v=>{
          v.typeName = queryActivityCategory({
            parentId: v.promotionCode.split("-")[0],
            childId: v.promotionCode.split("-")[1],
          }).childTypeName;
          v.startDate = v.promotionStartTime;
          v.endDate = v.promotionEndTime;
        })
        this.selectedData = this.connectedActiviesList;
        }
        console.log("this.connectedActiviesList:",this.connectedActiviesList);
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
  .caption {
    position: relative;
    padding-left: 10px;
    color: #000;
    margin-bottom: 20px;
    &::before {
      position: absolute;
      left: 0;
      width: 4px;
      height: 100%;
      background: #e50065;
      content: "";
      border-top-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}
.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
// .success-bg{
//   background: #2fc348 !important;
// }
// .danger-bg{
//   background: #ff0000 !important;
// }
// .gray-bg{
//   background: #B7B7B7 !important;
// }
</style>
